<template>
    <div><!--NO USE OF COMPONENT DIRECTLY--></div>
</template>

<script>
import resources from '../helpers/resources'
import axios from 'axios'

export default {
  mounted () {
    axios.interceptors.response.use(config => {
      return config
    }, error => {
      return this.toastError(error)
    })
  },
  methods: {
    toastError (error) {
      this.$bvToast.toast(resources.standardErrorMessage, {
        title: resources.standardErrorTitle,
        variant: 'danger',
        solid: true,
        appendToast: true
      })
      return Promise.reject(error)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Toaster.vue